const METRICA_SCRIPT_ID = 'yandex-metrica-script';
const METRICA_SCRIPT_URL = 'https://mc.yandex.ru/metrika/tag.js';

let initialized = false;
let scriptPromise = null;
let initializationVersion = 0;

export const COOKIE_CONSENT_KEY = 'cookieAccepted';

export function getYandexMetricaId() {
  const rawId = process.env.REACT_APP_YANDEX_METRICA_ID?.trim();

  if (!rawId || !/^\d+$/.test(rawId)) {
    return null;
  }

  return Number(rawId);
}

function loadMetricaScript() {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.ym && document.getElementById(METRICA_SCRIPT_ID)) {
    return Promise.resolve();
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  window.ym = window.ym || function ymQueue() {
    (window.ym.a = window.ym.a || []).push(arguments);
  };
  window.ym.l = window.ym.l || Date.now();

  scriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(METRICA_SCRIPT_ID);
    const script = existingScript || document.createElement('script');

    script.addEventListener('load', resolve, { once: true });
    script.addEventListener(
      'error',
      () => {
        scriptPromise = null;
        script.remove();
        reject(new Error('Не удалось загрузить Яндекс Метрику'));
      },
      { once: true }
    );

    if (!existingScript) {
      script.id = METRICA_SCRIPT_ID;
      script.async = true;
      script.src = METRICA_SCRIPT_URL;
      document.head.appendChild(script);
    }
  });

  return scriptPromise;
}

export async function initializeYandexMetrica() {
  const counterId = getYandexMetricaId();

  if (!counterId || typeof window === 'undefined') {
    return false;
  }

  if (initialized) {
    return true;
  }

  const version = initializationVersion;
  await loadMetricaScript();

  if (version !== initializationVersion || !window.ym) {
    return false;
  }

  window.ym(counterId, 'init', {
    defer: true,
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
  });
  initialized = true;

  return true;
}

export function destroyYandexMetrica() {
  initializationVersion += 1;
  initialized = false;
}

export function hitYandexMetrica(url, options) {
  const counterId = getYandexMetricaId();

  if (!counterId || typeof window === 'undefined' || !window.ym || !initialized) {
    return;
  }

  window.ym(counterId, 'hit', url, options);
}

export function reachYandexMetricaGoal(goal, params) {
  const counterId = getYandexMetricaId();

  if (!counterId || typeof window === 'undefined' || !window.ym || !initialized) {
    return;
  }

  window.ym(counterId, 'reachGoal', goal, params);
}
